module.exports = __webpack_public_path__ + "static/media/galerija_2016 (11).966c8390.jpg";